import { FEATURE_FLAG_INSTORE_PROMOTION } from '@config/feature-flag';
import { isWithinDateRangePST } from '@utils/dateAndTime/isBetween';
import styles from './InStorePromoMessage.module.scss';
import { useLocale } from '@hooks/useLocale';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import linkResolver from '@adapters/prismic/utils/linkResolver';
import spuPromoData from '../../../../prismic-spu-promo.json';

interface SpuPromo {
  offerName: RichTextBlock[];
  startDate: string;
  endDate: string;
  offerText: RichTextBlock[];
}

interface SpuPromoData {
  en: SpuPromo[];
  fr: SpuPromo[];
}

const InStorePromotion = () => {
  const locale = useLocale();
  if (!FEATURE_FLAG_INSTORE_PROMOTION) {
    return null;
  }

  const promos = (spuPromoData as SpuPromoData)[locale as 'en' | 'fr'] || [];

  const activePromo = promos.find((promo) =>
    isWithinDateRangePST(promo.startDate, promo.endDate)
  );

  if (!activePromo) {
    return null;
  }

  return (
    <div className={styles.inStorePromoMessage}>
      <RichText render={activePromo.offerText} linkResolver={linkResolver} />
    </div>
  );
};

export default InStorePromotion;
